import {Enum, LocalizedEnum} from "../../common/enum/enum";

/**
 * Severity levels
 * @extends LocalizedEnum
 * @hideconstructor
 */
class EDIDSeverityEnum extends LocalizedEnum {
    static MODERATE = new EDIDSeverityEnum(1, 'edid.enum.severity.moderate', 'rgb(255,252,59)');
    static SEVERE = new EDIDSeverityEnum(2, 'edid.enum.severity.severe', 'rgb(255,202,47)');
    static EXTREME = new EDIDSeverityEnum(3, 'edid.enum.severity.extreme', 'rgb(255,0,11)');

    constructor(code,key,colour) {
        super(code,key);
        this.colour = colour;
    }

    getColour(){
        return this.colour;
    }

    static getForCode(code) {
        return Enum._getForCode(EDIDSeverityEnum, code);
    }

    static exists(code) {
        return Enum._exists(EDIDSeverityEnum, code);
    }

    static getPossibleCodes() {
        return Enum._getPossibleCodes(EDIDSeverityEnum)
    }

    static getPossibleValues() {
        return Enum._getPossibleValues(EDIDSeverityEnum)
    }
}

export {EDIDSeverityEnum}